<script>
  import TextInput from '../../../../components/inputs/text';
  import CoordinatorInput from '../../../../components/inputs/coordinator';
  import CategoryInput from '../../../../components/inputs/category';
  import Form from '../../../../components/inputs/form';
  import Trash from '../../../../components/buttons/trash.card';

  export let value;
  export let readonly = false;

  function addContact() {
    value = {
      ...value,
      contacts: [...value.contacts, { name: '', email: '', phone: '' }]
    };
  }

  function removeContact(i) {
    value = {
      ...value,
      contacts: value.contacts.filter((contact, index) => i !== index)
    };
  }
</script>

<div>
  <Form>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <div class="form-group">
          <TextInput readonly="{readonly}" bind:value={value.organization} label="Organization Name"
          placeholder="Organization Name" />
        </div>
      </div>
      <div class="cell small-12">
        <div class="form-group">
          <TextInput readonly="{readonly}" bind:value={value.addressLineOne} label="Program Address
          Line 1" placeholder="Program Address Line 1" />
        </div>
      </div>
      <div class="cell small-12">
        <div class="form-group">
          <TextInput readonly="{readonly}" bind:value={value.addressLineTwo} label="Program Address
          Line 2" placeholder="Program Address Line 2" />
        </div>
      </div>
      <div class="cell small-12 medium-5">
        <div class="form-group">
          <TextInput readonly="{readonly}" bind:value={value.city} label="City" placeholder="City"
          />
        </div>
      </div>
      <div class="cell small-12 medium-4">
        <div class="form-group">
          <TextInput readonly="{readonly}" bind:value={value.state} label="State"
          placeholder="State" />
        </div>
      </div>
      <div class="cell small-12 medium-3">
        <div class="form-group">
          <TextInput readonly="{readonly}" bind:value={value.postal} label="Zipcode"
          placeholder="Zipcode" />
        </div>
      </div>
      <div class="cell small-12">
        <div class="form-group form-group-repeater">
          {#each value.contacts as contact, i}
          <Form>
            {#if !readonly}
              <Trash on:click={() => removeContact(i)} />
            {/if}
            <div class="form-group">
              <TextInput readonly="{readonly}" bind:value={contact.name} label="Name"
              placeholder="Name" />
            </div>
            <div class="form-group">
              <TextInput readonly="{readonly}" bind:value={contact.email} label="Email"
              placeholder="Email" />
            </div>
            <div class="form-group">
              <TextInput readonly="{readonly}" bind:value={contact.phone} label="Phone"
              placeholder="Phone" />
            </div>
          </Form>
          {/each}
          {#if !readonly}
          <div on:click="{addContact}" class="form-group-add">
            Add Partner Contact
          </div>
          {/if}
        </div>
      </div>
    </div>
  </Form>
</div>
